module.exports = __webpack_public_path__ + "img/file.76c0ce66.jpg";